import jaJP from './ikkodate-locales/ja-JP'
import zhCN from './ikkodate-locales/zh-CN'
import zhTW from './ikkodate-locales/zh-TW'
import enUS from './ikkodate-locales/en-US'
import frFR from './ikkodate-locales/fr-FR'
import { evaluationMessages } from './evaluation-messages'

const messagesByLocale = {
  'ja-JP': jaJP,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en-US': enUS,
  'fr-FR': frFR
}

export function mergeIkkodateMessages(baseMessages, locale) {
  const ikkodateMessages = stripElementUiMessages(messagesByLocale[locale])
  return deepMerge(deepMerge(baseMessages || {}, ikkodateMessages), { evaluation: evaluationMessages[locale] })
}

function stripElementUiMessages(messages) {
  if (!messages || typeof messages !== 'object') return {}
  const { el: _el, ...rest } = messages
  return rest
}

function deepMerge(base, extra) {
  const result = { ...(base || {}) }
  Object.keys(extra || {}).forEach(key => {
    const baseValue = result[key]
    const extraValue = extra[key]
    if (isPlainObject(baseValue) && isPlainObject(extraValue)) {
      result[key] = deepMerge(baseValue, extraValue)
      return
    }
    result[key] = extraValue
  })
  return result
}

function isPlainObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value)
}
